import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const TextInput = styled.input`
    border-radius: 0px;
    width: 100%;
    padding: 5px;
`;

//stateless functional component for the text input
//we pass in the change handler, the id and a copy of the current form data (stored in sessionStorage when the user performs a search)
//in order to keep the form values when the user goes back to the search form
const SearchFormTextInput = ({
    changeHandler, 
    id, 
    formData}
) => (
    <TextInput onChange={changeHandler} type="text" value={(formData.hasOwnProperty(id)) ? formData[id] : ''} name={id} id={id} />
) 

SearchFormTextInput.propTypes = {
    changeHandler: PropTypes.func,
    id: PropTypes.string,
    formData: PropTypes.object,
}

export default SearchFormTextInput;


// WEBPACK FOOTER //
// ./src/components/searchForm/components/searchFormInput.js